import { render } from "./PowerRechargeForm.vue?vue&type=template&id=701a45de"
import script from "./PowerRechargeForm.vue?vue&type=script&lang=js"
export * from "./PowerRechargeForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Junior/ProjectPile/smartpile-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__